import AiAgentsIndex from './Index.vue';
import AiAgentShow from './Show.vue';
import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/ai-agents'),
      meta: {
        permissions: ['administrator'],
      },
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'ai_agents',
          component: AiAgentsIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: ':id',
          name: 'ai_agent_show',
          component: AiAgentShow,
          meta: {
            permissions: ['administrator'],
            fullWidth: true,
          },
        },
      ],
    },
  ],
};
